import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'

import { OrderItemType, OrderListItem, OrderStatus } from './index'

export enum CampaignPaymentState {
  InProgress = 'in_progress',
  Failed = 'failed',
}

export type CampaignPayment = {
  state: CampaignPaymentState
  orderId: number
}

export const PLATFORM_TO_ORDER_ITEM_TYPE: Partial<
  Record<CampaignPlatformTypeEnum, OrderItemType>
> = {
  [CampaignPlatformTypeEnum.SPOTIFY]: OrderItemType.SpotifyCampaign,
  [CampaignPlatformTypeEnum.TIKTOK]: OrderItemType.TiktokCampaign,
  [CampaignPlatformTypeEnum.META]: OrderItemType.AdCampaign,
}

const ORDER_ITEM_TYPE_TO_PLATFORM: Partial<
  Record<OrderItemType, CampaignPlatformTypeEnum>
> = {
  [OrderItemType.SpotifyCampaign]: CampaignPlatformTypeEnum.SPOTIFY,
  [OrderItemType.TiktokCampaign]: CampaignPlatformTypeEnum.TIKTOK,
  [OrderItemType.AdCampaign]: CampaignPlatformTypeEnum.META,
}

export const findOrderCampaign = (
  items: { type: OrderItemType; sourceId: number }[],
): { platform: CampaignPlatformTypeEnum; campaignId: number } | null => {
  for (const item of items) {
    const platform = ORDER_ITEM_TYPE_TO_PLATFORM[item.type]
    if (platform) {
      return { platform, campaignId: item.sourceId }
    }
  }
  return null
}

export const getCampaignPayment = (
  orders: OrderListItem[],
  platform: CampaignPlatformTypeEnum,
  campaignId: number,
  hasPaymentReturn: boolean,
): CampaignPayment | null => {
  const itemType = PLATFORM_TO_ORDER_ITEM_TYPE[platform]
  const order = orders.find((candidate) =>
    candidate.items.some(
      (item) => item.type === itemType && item.sourceId === campaignId,
    ),
  )

  if (!order) {
    return null
  }

  if (order.status === OrderStatus.CheckoutFailed) {
    return { state: CampaignPaymentState.Failed, orderId: order.id }
  }

  const isPaymentSent = order.status === OrderStatus.PaymentSent
  const isAwaitingConfirmation =
    order.status === OrderStatus.Checkout && hasPaymentReturn

  return isPaymentSent || isAwaitingConfirmation
    ? { state: CampaignPaymentState.InProgress, orderId: order.id }
    : null
}
